import React from 'react';
import PropTypes from 'prop-types';
import Styled from './DataGrid.styles';
import { getObjectFields } from './utils';

const value = item => {
  if (Array.isArray(item)) return item.map(i => i.value).join('<br />');
  if (typeof item === 'object') return item.value;
  return item;
};

const DataGridItem = ({ item }) => {
  return (
    <Styled.Row>
      {getObjectFields(item).map(key => (
        <Styled.Column
          key={`${item.id}-${key}`}
          dangerouslySetInnerHTML={{ __html: value(item[key]).toString() }}
        />
      ))}
    </Styled.Row>
  );
};

DataGridItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
};

export default React.memo(DataGridItem);
